import { Component, OnInit, Inject } from '@angular/core';
import { MatTableDataSource, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SnackbarService } from 'src/app/snackbar.service';
import { HttpService } from 'src/app/http.service';
import { TimeService } from 'src/app/time.service';
import { Messages } from '../../constants/messages';

@Component({
  selector: 'app-create-bill-modal',
  templateUrl: './create-bill-modal.component.html',
  styleUrls: ['./create-bill-modal.component.scss']
})
export class CreateBillModalComponent implements OnInit {

  displayColumns = ['SIN', 'pickup_address', 'drop_address'];
  bills_details: MatTableDataSource<any>;
  billing_address;
  invoiceArray = [];
  filters;
  invoices = [];
  type;
  rejected_ids = []; // holds the rejected ids of invoices
  messages = new Messages();


  constructor(public dialogRef: MatDialogRef<CreateBillModalComponent>, @Inject(MAT_DIALOG_DATA) public data, public snackbar: SnackbarService,
              private http: HttpService, private timeService: TimeService) { }

  ngOnInit() {
    this.billing_address = this.data.location ? this.data.location.area : ''; // sets the billing address of the shipper
    this.filters = this.data.filters; // get the filters
    this.invoiceArray = this.data.selectedInvoices; // set the invoices array to selected invoices
    this.rejected_ids = this.data.rejected_ids;// set the rejected ids
    this.type = this.data.type;

    this.invoiceArray.forEach((element) => {
      const temp: any = {};
      temp.SIN = element.shipment_id;
      temp.pickups = element.pickups.map((e) => {
        // returns the pickups array
        return {
          locality: e.location.locality ? e.location.locality : e.location.area
        };
      });
      temp.deliveries = element.deliveries.map((e) => {
        // returns the deliveries array
        return {
          locality: e.location.locality ? e.location.locality : e.location.area
        };
      });
      this.invoices.push(temp);
    });
    this.bills_details = new MatTableDataSource(this.invoices);
  }

  createBill() {
    let valid = true;

    const payload: any = {
      shipper: this.filters.shipper,
      from_date: this.timeService.toUTCEpoch(this.filters.from_date),
      to_date: this.timeService.toUTCEpoch(this.filters.to_date),
      address: this.billing_address,
      shipment_addresses: []
    };


    // add the shipment address to payload
    payload.shipment_addresses = this.invoices.map((e) => {
      // take only the locality string
      const pickups = e.pickups.map((p) => {
        return p.locality;
      });
      // take only the locality string
      const deliveries = e.deliveries.map((d) => {
        return d.locality;
      });
      return {
        SIN: e.SIN,
        pickups,
        deliveries
      };
    });

    // //add rejected ids if present to the payload
    // if(this.rejected_ids && this.rejected_ids.length){
    //   payload.rejected_ids = this.rejected_ids;
    // }

    // check for the billing address
    if (!payload.address) {
      valid = false;
      this.snackbar.openSnackBar(this.messages.CREATE_BILL_MODAL.VALIDATION.BILLING_ADDRESS, '', 'err');
    }
    if (valid) {
      this.http.post('carrier_bill/create', payload, 1).subscribe(
        (data: any) => {
          if (data.statusCode === 200) {
            this.snackbar.openSnackBar(this.messages.CREATE_BILL_MODAL.SUCCESS.BILL);
            this.dialogRef.close(data);
          }
        },
        (err: any) => {
          this.snackbar.openSnackBar(err.error.message, '', 'err');
        }
      );
    }
  }
  closeModal() {
    this.dialogRef.close();
  }

}
